/* eslint-disable jsx-a11y/anchor-is-valid */
import defaultAvatar from "@assets/img/avatars/defaultAvatar.png";
import { ModalNotificationView } from "@components/modals/modal-notification-view";
import { useAuthContext } from "@hooks/contexts/auth-context";

import { useSidebarCollapse } from "@hooks/contexts/SidebarCollapseContext";
import { useTopbarCollapse } from "@hooks/contexts/TopbarCollapseContext";
import {
  CustomerNotificationDTO,
  CustomerNotificationStatusEnum,
  CustomerNotificationStatusTypes,
} from "@hooks/dtos/ICustomerNotificationDTO";
import { Masks } from "@hooks/functions/Masks/Masks";
import { formatName } from "@hooks/functions/formatName";
import {
  changeNotificationStatus,
  getNotificationProperty,
  getNotificationReadActionStatus,
} from "@hooks/functions/Notification/Notification";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  FaAngleRight,
  FaArrowRightFromBracket,
  FaBell,
  FaRegBell,
} from "react-icons/fa6";
import Skeleton from "react-loading-skeleton";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const masks = new Masks();
export default function NavbarTop() {
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();
  const navigate = useNavigate();
  const { toggleSidebar } = useSidebarCollapse();
  const { toggleTopbar } = useTopbarCollapse();
  const { client } = ZuAuthStore();
  const { signOut } = useAuthContext();
  const clientName = client?.client?.name
    ? formatName(client.client.name)
    : "John Doe";

  // --- Notification Modal --- //
  const [notificationId, setNotificationId] = useState<number>();

  const [isLoadNotifications, setLoadNotifications] = useState<boolean>(true);
  const [unreadNotificationCount, setUnreadNotificationCount] =
    useState<number>(0);
  const [unreadNotifications, setUnreadNotifications] = useState<
    CustomerNotificationDTO[]
  >([]);

  const getNotificationCount = async () => {
    try {
      const params = `?status=${CustomerNotificationStatusEnum.UNREAD}`;
      const result = await api.get(`/notification/count${params}`);
      setUnreadNotificationCount(result.data);
    } catch (err: any) {
      console.error(err);
    }
  };

  const getLastestNotifications = async (force?: boolean) => {
    if (!isLoadNotifications && !force) return;
    try {
      const params = `?status=${CustomerNotificationStatusEnum.UNREAD}&page=1&take=5`;
      const result = await api.get(`/notification/list${params}`);
      const _unreadNotifications = result?.data?.list;
      setUnreadNotifications(_unreadNotifications);
      if (_unreadNotifications.length > 0) {
        getNotificationCount();
      }
      setLoadNotifications(false);
    } catch (err: any) {
      console.error(err);
    }
  };

  const handleChangeNotificationStatus = async (
    notificationId: number,
    status: CustomerNotificationStatusTypes,
    message: string,
  ) => {
    Swal.fire({
      title: "Alterar Status?",
      text: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, continuar!",
      cancelButtonText: "Cancelar",
    }).then(async (result: { isConfirmed: boolean }) => {
      if (result.isConfirmed) {
        try {
          await changeNotificationStatus({
            notificationId,
            status,
          });

          getNotificationCount();
          getLastestNotifications(true);
        } catch (err: any) {
          pushToastify({
            message: err.message || "Ocorreu um erro!",
            type: "error",
            theme: "dark",
          });
        }
      }
    });
  };

  useEffect(() => {
    getNotificationCount();
  }, []);

  return (
    <>
      <div className="main-header">
        <div className="main-header-logo">
          <div className="logo-header" data-background-color="dark">
            <div className="nav-toggle">
              <button
                className="btn btn-toggle sidenav-toggler "
                onClick={toggleSidebar}
              >
                <i className="gg-menu-left m-2"></i>
              </button>
            </div>
            <button className="topbar-toggler more p-3" onClick={toggleTopbar}>
              <i className="gg-more-vertical-alt"></i>
            </button>
          </div>
        </div>

        <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
          <div className="container-fluid">
            <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
              {/* Notifications */}
              <li className="nav-item topbar-icon dropdown hidden-caret">
                <a
                  className="nav-link dropdown-toggle fs-4"
                  href="#"
                  id="notifDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => {
                    getLastestNotifications();
                  }}
                >
                  {unreadNotificationCount > 0 ? <FaBell /> : <FaRegBell />}
                  {unreadNotificationCount > 0 && (
                    <span className="notification">
                      {masks.formatMilhar(unreadNotificationCount)}
                    </span>
                  )}
                </a>
                <ul
                  className="dropdown-menu notif-box animated fadeIn"
                  aria-labelledby="notifDropdown"
                >
                  <li>
                    <div className="dropdown-title">
                      {unreadNotificationCount > 0
                        ? `Você tem ${masks.formatMilhar(unreadNotificationCount)} notificaç${unreadNotificationCount > 1 ? `ões` : `ão`} não lida${unreadNotificationCount > 1 ? `s` : ``}`
                        : `Você não tem notificação não lida`}
                    </div>
                  </li>

                  {isLoadNotifications ? (
                    <li>
                      <div className="notif-center text-center p-2">
                        <Skeleton count={3} />
                      </div>
                    </li>
                  ) : unreadNotifications.length === 0 ? (
                    <li>
                      <div className="notif-center text-center p-2">
                        <span>Nenhuma notificação não lida</span>
                      </div>
                    </li>
                  ) : (
                    unreadNotifications.map((notification, index) => {
                      const notificationProperty = getNotificationProperty({
                        subCategoryId: notification.subCategoryData.id,
                        groupKey: notification.subCategoryData.groupKey,
                      });

                      const action = getNotificationReadActionStatus({
                        status: notification.status,
                      });

                      return (
                        <li key={index}>
                          <div className="notif-scroll scrollbar-outer">
                            <div className="notif-center">
                              <div className="d-flex justify-content-between align-items-center">
                                <div
                                  className={`col-md-${action ? `10` : `12`}`}
                                >
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setNotificationId(notification.id);
                                    }}
                                  >
                                    <div
                                      className="notif-icon"
                                      style={{
                                        backgroundColor:
                                          notificationProperty.bgColor,
                                      }}
                                    >
                                      <notificationProperty.icon
                                        className="fs-5"
                                        title={`${notification.categoryData.title}: ${notification.categoryData.description}`}
                                        style={{
                                          color: notificationProperty.textColor,
                                        }}
                                      />
                                    </div>
                                    <div className="notif-content">
                                      <span className="block">
                                        {
                                          notification.subCategoryData.title
                                        }{" "}
                                      </span>
                                      <span className="time">
                                        {dayjs(notification.createdAt).format(
                                          "DD/MM/YYYY [às] HH:mm:ss",
                                        )}
                                      </span>
                                    </div>
                                  </a>
                                </div>
                                {action ? (
                                  <div className="col-md-2 text-end pe-3">
                                    <span
                                      className=""
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleChangeNotificationStatus(
                                          notification.id,
                                          action.newStatus,
                                          action.text,
                                        );
                                      }}
                                    >
                                      <action.icon className="fs-5" />
                                    </span>
                                  </div>
                                ) : (
                                  <span></span>
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  )}

                  <li className="text-center">
                    <Link className="see-all" to={`/notifications`}>
                      Ver tudo
                      <FaAngleRight />
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Profile */}
              <li className="nav-item topbar-user dropdown hidden-caret">
                <a
                  className="dropdown-toggle profile-pic"
                  data-bs-toggle="dropdown"
                  href="#"
                  aria-expanded="false"
                >
                  <div className="avatar-sm">
                    <img
                      src={defaultAvatar}
                      alt="..."
                      className="avatar-img rounded-circle"
                    />
                  </div>
                  <span className="profile-username">
                    <span className="fw-bold text-capitalize">
                      {clientName}
                    </span>
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-user animated fadeIn">
                  <div className="dropdown-user-scroll scrollbar-outer">
                    <li>
                      <div className="user-box">
                        <div className="avatar-lg">
                          <img
                            src={defaultAvatar}
                            alt="image profile"
                            className="avatar-img rounded-circle"
                          />
                        </div>
                        <div className="u-text">
                          <h4 className="mb-2">
                            {clientName}
                          </h4>
                          <a
                            href="/account"
                            className="btn btn-xs btn-secondary btn-sm"
                          >
                            Minha Conta
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-divider"></div>
                      <a
                        className="dropdown-item text-end text-danger"
                        onClick={signOut}
                        href="#"
                      >
                        Sair
                        <FaArrowRightFromBracket className="ms-2" />
                      </a>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      {notificationId && (
        <ModalNotificationView
          notificationId={notificationId}
          isOpen={notificationId > 0}
          onClose={(updated) => {
            setNotificationId(undefined);
            if (updated) {
              getNotificationCount();
              getLastestNotifications(true);
            }
          }}
        />
      )}
    </>
  );
}
